import { render, staticRenderFns } from "./SideBlock.vue?vue&type=template&id=5040b842"
import script from "./SideBlock.vue?vue&type=script&lang=js"
export * from "./SideBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports